module.exports = __webpack_public_path__ + "img/v01.b71dd5fc.jpg";